<div *ngIf="isReady$|async" class="site-root">
  <app-splash-screen></app-splash-screen>
  <router-outlet name="header"></router-outlet>
  <router-outlet class="site-content"></router-outlet>
  <app-footer *ngIf="dataLoaded"></app-footer>
</div>
<link *ngIf="!!(themeCssUrl$|async)" [href]="themeCssUrl$|async"
      appMoveToHead rel="stylesheet"/>
